<template>
    <div class='cmpr-table'>
        <table class="simple-tbl" style="min-width:400px;margin-bottom:20px;">
            <thead class="head">
            <tr class="row">
                <!-- 共用列 -->
                <th class="comn-col col-last" style="text-align: center;border-bottom:1px solid #DDD" :colspan="comnColNames.length">{{ comnColsTitle }}</th>
                <!-- 比较列 -->
                <template v-for=" (colsTitle, groupIndex) in cmprColsTitles">
                    <th class="col-last" :class="{'odd-group-cols' : groupIndex %2 == 0, 'even-group-cols' : groupIndex %2 == 1}" style="text-align: center;border-bottom:1px solid #DDD;" :colspan="cmprColNames.length">
                        {{ colsTitle }}
                    </th>
                </template>
            </tr>
            <tr class="row">
                <!-- 共用列 -->
                <template v-for="(colName, index) in comnColNames">
                    <th class="col-last" v-if="index == comnColNames.length-1">
                        <div style="display:inline-block;" :style="getComnColStyle(null, colName)">{{ dataColTitles[colName] }}</div>
                    </th>
                    <th class="" v-else>
                        <div style="display:inline-block;" :style="getComnColStyle(null, colName)">{{ dataColTitles[colName] }}</div>
                    </th>
                </template>

                <!-- 比较列 -->
                <template v-for=" (colsTitle, groupIndex) in cmprColsTitles">
                    <template v-for="(colName, index) in cmprColNames">
                        <th class="col-last" v-if="index == cmprColNames.length-1">
                            <div style="display:inline-block;" :style="getCmprColStyle(colsTitle, null, colName)">{{ dataColTitles[colName] }}</div>
                        </th>
                        <th class="" v-else>
                            <div style="display:inline-block;" :style="getCmprColStyle(colsTitle, null, colName)">{{ dataColTitles[colName] }}</div>
                        </th>
                    </template>
                </template>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="uk in comnUkList">
                <!-- 共用列 -->
                <template v-for="(colName, index) in comnColNames">
                    <td class="comn-col col-last" :style="getComnColStyle(uk, colName)" v-if="index == comnColNames.length-1">
                        {{ getComnRowColTextByUk(uk, colName) }}
                    </td>
                    <td class="comn-col" :style="getComnColStyle(uk, colName)" v-else>{{ getComnRowColTextByUk(uk, colName) }}</td>
                </template>

                <!-- 比较列 -->
                <template v-for=" (colsTitle, groupIndex) in cmprColsTitles">
                    <template v-for="(colName, index) in cmprColNames">
                        <td class="col-last" :class="{'odd-group-cols' : groupIndex %2 == 0, 'even-group-cols' : groupIndex %2 == 1}" :style="getCmprColStyle(colsTitle, uk, colName)" v-if="index == cmprColNames.length-1">
                            {{ getCmprRowColTextByUk(colsTitle, uk, colName) }}
                        </td>
                        <td class="" :class="{'odd-group-cols' : groupIndex %2 == 0, 'even-group-cols' : groupIndex %2 == 1}" :style="getCmprColStyle(colsTitle, uk, colName)" v-else>
                            {{ getCmprRowColTextByUk(colsTitle, uk, colName) }}
                        </td>
                    </template>
                </template>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    let KeyMap = Utils.KeyMap;
    //
    const ukColName = '_uk_';

    function reformData(dataLists, dataColumns, ukFunc, sortFunc) {
        let retInfo = {};
        console.log(dataColumns);
        let dataColTitles = {};
        retInfo['dataColTitles'] = dataColTitles;
        let dataColStyles = {};
        retInfo['dataColStyles'] = dataColStyles;
        dataColumns.forEach(function (col) {
            let colName = col.name;
            dataColTitles[colName] = col.title;
            //
            let colStyle = {};
            dataColStyles[colName] = colStyle;
            if(col.align != null) {
                colStyle['text-align'] = col.align;
            }
            if(col.width != null) {
                colStyle['width'] = col.width + 'px';
            }
            if(col.color != null) {
                colStyle['color'] = col.color;
            }
        });
        //
        let cmprColsTitles = dataLists.pluck('colsTitle');
        retInfo['cmprColsTitles'] = cmprColsTitles;
        console.log(cmprColsTitles);
        //
        let dataListArys = dataLists.pluck('dataList');
        //
        let dataListMap = {};
        let tmpUkDataMap = {};//防重
        for(let i = 0; i < cmprColsTitles.length; i++) {
            let colsTitle = cmprColsTitles[i];
            let dataList = dataListArys[i];
            dataListMap[colsTitle] = dataList;
            //
            dataList.forEach(function (datum) {
                let uk = ukFunc(datum);
                datum[ukColName] = uk;
                tmpUkDataMap[uk] = datum;
            });
        }
        retInfo['dataListMap'] = dataListMap;
        //
        let comnDataList = [];
        for(let uk in tmpUkDataMap) {
            comnDataList.add(tmpUkDataMap[uk]);
        }
        //
        comnDataList = Utils.sortArray(comnDataList, sortFunc);
        retInfo['comnDataList'] = comnDataList;
        console.log(comnDataList);

        let comnUkList = comnDataList.pluck(ukColName);
        retInfo['comnUkList'] = comnUkList;
        console.log(comnUkList);
        //
        return retInfo;
    }

    export default {
        name: 'swb-cmpr-table',
        desc: '数据比对表格',
        props: {
            dataLists: {//数据信息列表
                type: Array // [{colsTitle, dataList}, ...]
            },
            //
            comnColNames: {//共用列 名称列表
                type: Array
            },
            cmprColNames: {//比较列 名称列表
                type: Array
            },
            dataColumns: {//列元数据信息（其中 color 可以是函数(colValue, datum)）
                type: Array // [{name, title, align, width, color}, ...]
            },
            comnColsTitle: {
                type: String,
                default: '公共信息'
            },
            //返回唯一键（字符串）的回调函数
            ukFunc: {//(datum)
                type: Function
            },
            //提供排序的回调函数
            sortFunc: {//(datum1, datum2)
                type: Function
            },
            //
            dataColTextFunc: {
                type: Function,
                default: function (datum, colName) {
                    return datum[colName] || null;
                }
            }
        },
        data() {
            //
            return {
                dataColTitles: {},
                dataColStyles: {},
                cmprColsTitles: [],
                dataListMap: {},
                comnUkList: [],
                comnDataList: []
            };
        },
        computed: {},
        watch: {
            dataLists(newVal, oldVal) {
                this.toReformData();
            }
        },
        created() {
            this.toReformData();
        },
        mounted() {
            this.toReformData();
        },
        beforeDestroy() {
            //data
            this.dataColTitles = null;
            this.dataColStyles = null;
            this.cmprColsTitles = null;
            this.dataListMap = null;
            this.comnUkList = null;
            this.comnDataList = null;
            //props
            this.dataLists = null;
            this.comnColNames = null;
            this.cmprColNames = null;
            this.dataColumns = null;
            this.ukFunc = null;
            this.sortFunc = null;
            this.dataColTextFunc = null;
        },
        methods: {
            toReformData() {
                let reformedData = reformData(this.dataLists, this.dataColumns, this.ukFunc, this.sortFunc);
                this.dataColTitles = reformedData.dataColTitles;
                this.dataColStyles = reformedData.dataColStyles;
                this.cmprColsTitles = reformedData.cmprColsTitles;
                this.dataListMap = reformedData.dataListMap;
                this.comnUkList = reformedData.comnUkList;
                this.comnDataList = reformedData.comnDataList;
            },
            //
            getComnRow(uk) {
                if(uk == null) {
                    return null;
                }
                //
                return this.comnDataList.find(function (row) {
                    return row[ukColName] == uk;
                });
            },
            getCmprRow(colsTitle, uk) {
                if(uk == null) {
                    return null;
                }
                //
                let dataList = this.dataListMap[colsTitle];
                return dataList.find(function (row) {
                    return row[ukColName] == uk;
                });
            },
            //
            getComnColStyle(uk, colName) {
                let style = this.dataColStyles[colName];
                style = Utils.merge(style);
                let color = style['color'];
                if(color != null && typeof color == 'function') {
                    let datum = this.getComnRow(uk);
                    let color2 = color(datum == null ? null : datum[colName], datum);
                    if(color2 == null) {
                        delete style['color'];
                    }
                    else {
                        style['color'] = color2;
                    }
                }
                return style;
            },
            getCmprColStyle(colsTitle, uk, colName) {
                let style = this.dataColStyles[colName];
                let color = style['color'];
                style = Utils.merge(style);
                if(color != null && typeof color == 'function') {
                    let datum = this.getCmprRow(colsTitle, uk);
                    let color2 = color(datum == null ? null : datum[colName], datum);
                    if(color2 == null) {
                        delete style['color'];
                    }
                    else {
                        style['color'] = color2;
                    }
                }
                return style;
            },
            //
            getComnRowColTextByUk(uk, colName) {
                let datum = this.getComnRow(uk);
                return datum == null ? '' : this.dataColTextFunc(datum, colName);
            },
            getCmprRowColTextByUk(colsTitle, uk, colName) {
                let datum = this.getCmprRow(colsTitle, uk);
                return datum == null ? '' : this.dataColTextFunc(datum, colName);
            }
        }
    }
</script>

<style scoped>
    .cmpr-table {
        overflow-x: auto;
    }

    .simple-tbl > .head > .row > .col-last {
        border-right: 1px solid #e5e5e5;
        border-top: 1px solid #e5e5e5;
    }

    .simple-tbl > .head > .row > .comn-col, .simple-tbl > .body > .row > .comn-col {
        background-color: #F8F8F8;
    }

    /** 奇数 分组样式 */
    .simple-tbl > .head > .row > .odd-group-cols, .simple-tbl > .body > .row > .odd-group-cols {
        background-color: #FFFFFF;
    }

    /** 偶数 分组样式 */
    .simple-tbl > .head > .row > .even-group-cols, .simple-tbl > .body > .row > .even-group-cols {
        background-color: #FEFEF0;
    }


</style>



// WEBPACK FOOTER //
// src/compo/ctrl/CmprTable.vue